import { render, staticRenderFns } from "./KIWTable.vue?vue&type=template&id=3a18a244&scoped=true"
import script from "./KIWTable.vue?vue&type=script&lang=js"
export * from "./KIWTable.vue?vue&type=script&lang=js"
import style0 from "./KIWTable.vue?vue&type=style&index=0&id=3a18a244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a18a244",
  null
  
)

export default component.exports